export default __webpack_public_path__ + "static/media/juice.f819b65b.png";